// Reactive "load once auth is ready" primitive.
//
// A view that fetches user-scoped data should implement `loadAuthedData()` and
// add this mixin instead of calling its fetch in created()/mounted(). The mixin
// invokes loadAuthedData() exactly when the initial session restore has settled
// AND the user is authenticated — covering the direct-page-load race where
// isAuthenticated is still false during restore. It also re-fires if the user
// logs in later in-session, and resets on logout so a subsequent login reloads.
import { mapGetters } from 'vuex';

export default {
  data() {
    return { loadedForAuth: false };
  },
  computed: {
    ...mapGetters('auth', { authReady: 'isInitialized', authedNow: 'isAuthenticated' }),
  },
  watch: {
    authReady: { immediate: true, handler() { this.maybeLoadAuthed(); } },
    authedNow(v) {
      if (!v) this.loadedForAuth = false;
      this.maybeLoadAuthed();
    },
  },
  methods: {
    maybeLoadAuthed() {
      if (this.authReady && this.authedNow && !this.loadedForAuth
          && typeof this.loadAuthedData === 'function') {
        this.loadedForAuth = true;
        this.loadAuthedData();
      }
    },
  },
};
